import React from "react";
import OrderHistorySectionCard from "@/features/my-order/features/order-history/components/OrderHistorySectionCard";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import OrderHistoryInvoiceContent from "@/features/my-order/features/order-history/components/invoice-section/OrderHistoryInvoiceContent";
import ButtonizedTooltip from "@/shared/components/ButtonizedTooltip";
import BankAccountInfoTooltipContent from "@/features/my-order/components/BankAccountInfoTooltipContent";

function OrderHistoryInvoiceSection() {
  return (
    <OrderHistorySectionCard
      titleKey={"order_history:invoice.invoice_info"}
      iconSrc={"bank"}
      actions={<InvoiceSectionActions />}
    >
      <OrderHistoryInvoiceContent />
    </OrderHistorySectionCard>
  );
}

export default OrderHistoryInvoiceSection;

const InvoiceSectionActions = () => {
  const { tTitle } = useI18nHelper();

  return (
    <ButtonizedTooltip
      label={tTitle("order_history:invoice.bank_account_info")}
    >
      <BankAccountInfoTooltipContent />
    </ButtonizedTooltip>
  );
};
